

















































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { dynamicFieldWebservice } from '@/webservices/dynamicField';
import type { DynamicField } from '@/models/dynamicField';
import type { User } from '@/models/user';
import UpdateDynamicFieldName from './UpdateDynamicFieldName.vue';
import type { CompanySetting } from '@/models/companySetting';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'DynamicFieldsList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        UpdateDynamicFieldName,
    },
})
export default class DynamicFieldsList extends Vue {
    private dynamicFields = new Array<DynamicField>();

    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };
    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    private mounted() {
        this.load();
    }

    private load() {
        dynamicFieldWebservice
            .load()
            .then((response) => {
                this.dynamicFields = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
